const headerStorage = {};

const transferHeadersConf = [
  "x-gd-project-env",
  "x-gd-traffic-tags",
  "traceparent",
  "user-trace-id",
  "user-info",
  "org-info",
  "AuthFailed-Info",
];

export function setTransferHeaders(headers) {
  transferHeadersConf.map((key) => {
    if (headers[key]) {
      headerStorage[key] = headers[key];
    } else {
      delete headerStorage[key];
    }
  });
}

export function getTransferHeaders() {
  return { ...headerStorage };
}
